import request from '@/utils/market/marketing'
// 促销规则
export function luckydrawruleadd(data) { // 新增规则
  return request({
    url: '/mtscitech/back/luckydrawrule/add',
    method: 'post',
    data
  })
}
export function luckydrawruledelete(query) { // 删除规则
  return request({
    url: '/mtscitech/back/luckydrawrule/delete',
    method: 'get',
    params: query
  })
}
export function findlistbyconditions(data) { // 规则列表查询
  return request({
    url: '/mtscitech/back/luckydrawrule/findlistbyconditions',
    method: 'post',
    data
  })
}
export function findlistbyobject(query) { // 查所有规则分页不含其他 条件
  return request({
    url: '/mtscitech/back/luckydrawrule/findlistbyobject',
    method: 'get',
    params: query
  })
}
export function luckydrawruleupdate(data) { // 修改规则
  return request({
    url: '/mtscitech/back/luckydrawrule/update',
    method: 'post',
    data
  })
}

export function deleteLuckydrawRuleDetail(query) { // 删除抽奖规则明细
  return request({
    url: '/mtscitech/back/luckydrawruledetail/deleteLuckydrawRuleDetail',
    method: 'get',
    params: query
  })
}
export function addLuckydrawRuleDetail(data) { // 新增抽奖规则明细
  return request({
    url: '/mtscitech/back/luckydrawruledetail/addLuckydrawRuleDetail',
    method: 'post',
    data
  })
}
export function findawardnamebyrule(query) { // 查询规则名称
  return request({
    url: '/mtscitech/back/luckydrawruledetail/findawardnamebyrule',
    method: 'get',
    params: query
  })
}
// 奖品管理 
export function addawardstuff(data) { // 添加奖品
    return request({
      url: '/mtscitech/back/awardstuff/addawardstuff',
      method: 'post',
      data
    })
  }
  export function updateawardstuff(data) { // 修改奖品
    return request({
      url: '/mtscitech/back/awardstuff/updateawardstuff',
      method: 'post',
      data
    })
  }
export function deleteawardstuff(query) { // 删除某行
    return request({
      url: '/mtscitech/back/awardstuff/deleteawardstuff',
      method: 'get',
      params: query
    })
  }
  export function findall(query) { // 列表查询
    return request({
      url: '/mtscitech/back/awardstuff/findall',
      method: 'get',
      params: query
    })
  }
  export function findone(query) { // 当行详情查询
    return request({
      url: '/mtscitech/back/awardstuff/findone',
      method: 'get',
      params: query
    })
  }
  export function findlistbytypeandgroup(query) { // 根据奖品类型和分组查询奖励物品集合
    return request({
      url: '/mtscitech/back/awardstuffcommon/findlistbytype',
      method: 'get',
      params: query
    })
  }
  export function queryFile(query) { // 获取图片文件接口
    return request({
      url: '/mtscitech/back/filegetter/queryFile',
      method: 'get',
      params: query
    })
  }
  export function luckydrawruleapplyadd(data) { // 出库单添加规则应用信息
    return request({
      url: '/mtscitech/back/luckydrawruleapply/add',
      method: 'post',
      data
    })
  }
  // 奖品管理 红包
  export function awardstuffRedPackageadd(data) { // 新增
    return request({
      url: '/mtscitech/back/awardstuffRedPackage/add',
      method: 'post',
      data
    })
  }
  export function awardstuffRedPackageupdate(data) { // 修改
    return request({
      url: '/mtscitech/back/awardstuffRedPackage/update',
      method: 'post',
      data
    })
  }
  export function awardstuffRedPackagefindall(query) { // 查询
    return request({
      url: '/mtscitech/back/awardstuffRedPackage/findall',
      method: 'get',
      params: query
    })
  }
  export function awardstuffRedPackagedel(query) { // 删除
    return request({
      url: '/mtscitech/back/awardstuffRedPackage/delete',
      method: 'get',
      params: query
    })
  }
    // 奖品管理 积分
    export function AccumulatePointadd(data) { // 新增
      return request({
        url: '/mtscitech/back/awardStuffAccumulatePoint/add',
        method: 'post',
        data
      })
    }
    export function AccumulatePointupdate(data) { // 修改
      return request({
        url: '/mtscitech/back/awardStuffAccumulatePoint/update',
        method: 'post',
        data
      })
    }
    export function AccumulatePointfindall(query) { // 查询
      return request({
        url: '/mtscitech/back/awardStuffAccumulatePoint/findall',
        method: 'get',
        params: query
      })
    }
    export function awardStuffAccumulatePointdel(query) { // 删除
      return request({
        url: '/mtscitech/back/awardStuffAccumulatePoint/delete',
        method: 'get',
        params: query
      })
    }
      // 奖品管理 实物
      export function awardStuffGoodsadd(data) { // 新增
        return request({
          url: '/mtscitech/back/awardStuffGoods/add',
          method: 'post',
          data
        })
      }
      export function awardStuffGoodsupdate(data) { // 修改
        return request({
          url: '/mtscitech/back/awardStuffGoods/update',
          method: 'post',
          data
        })
      }
      export function awardStuffGoodsfindall(query) { // 查询
        return request({
          url: '/mtscitech/back/awardStuffGoods/findall',
          method: 'get',
          params: query
        })
      }
      export function awardStuffGoodsdel(query) { // 删除
        return request({
          url: '/mtscitech/back/awardStuffGoods/delete',
          method: 'get',
          params: query
        })
      }
// 奖品管理 优惠卷
export function awardstuffVoucheradd(data) { // 新增
  return request({
    url: '/mtscitech/back/awardstuffVoucher/add',
    method: 'post',
    data
  })
}
export function awardstuffVoucherupdate(data) { // 修改
  return request({
    url: '/mtscitech/back/awardstuffVoucher/update',
    method: 'post',
    data
  })
}
export function awardstuffVoucherfindall(query) { // 查询
  return request({
    url: '/mtscitech/back/awardstuffVoucher/findall',
    method: 'get',
    params: query
  })
}
export function awardstuffVoucherdel(query) { // 删除
  return request({
    url: '/mtscitech/back/awardstuffVoucher/delete',
    method: 'get',
    params: query
  })
}
  // 促销政策  消费者模块
  export function findByConditions(query) { // 出库单列表
    return request({
      url: '/mtscitech/back/OutBillAssignedApplyConsumerController/findByConditions',
      method: 'get',
      params: query
    })
  }
  export function findUnAssignedByConditions(query) { // 出库单列表未分配
    return request({
      url: '/mtscitech/back/OutBillAssignedApplyConsumerController/findUnAssignedByConditions',
      method: 'get',
      params: query
    })
  }
  export function updatestate(data) { // 更新出库状态表
    return request({
      url: '/mtscitech/back/OutBillAssignedApplyConsumerController/updateStatus',
      method: 'post',
      data
    })
  }
  export function addInBatch(data) { // 批量配置出库单
    return request({
      url: '/mtscitech/back/OutBillAssignedApplyConsumerController/addInBatchForLuckyQueue',
      method: 'post',
      data
    })
  }
  export function statisticsOutBillAssigneds(data) { // 统计出库单集合箱码盒码总数
    return request({
      url: '/mtscitech/back/outbillassigned/statisticsOutBillAssigneds',
      method: 'post',
      data
    })
  }
   // 促销政策  分销商模块
   export function distributorfind(query) { // 出库单列表
    return request({
      url: '/mtscitech/back/OutBillAssignedApplyDistributorController/findByConditions',
      method: 'get',
      params: query
    })
  }
  export function distributorUnAssigned(query) { // 出库单列表未分配
    return request({
      url: '/mtscitech/back/OutBillAssignedApplyDistributorController/findUnAssignedByConditions',
      method: 'get',
      params: query
    })
  }
  export function distributorupdatestate(data) { // 更新出库状态表
    return request({
      url: '/mtscitech/back/OutBillAssignedApplyDistributorController/updateStatus',
      method: 'post',
      data
    })
  }
  export function distributoraddInBatch(data) { // 批量配置出库单
    return request({
      url: '/mtscitech/back/OutBillAssignedApplyDistributorController/addInBatchForLuckyQueue',
      method: 'post',
      data
    })
  }



  // 活动名称模块
  export function activityfindByConditions(data) { // 活动列表
    return request({
      url: '/mtscitech/back/activityList/findByConditions',
      method: 'post',
      data
    })
  }
  export function findAwardStuffVOByConditions(data) { // 活动列表活动明细
    return request({
      url: '/mtscitech/back/activityList/findAwardStuffVOByConditions',
      method: 'post',
      data
    })
  }
  export function findResultsByRuleApplyUUID(query) { // 出库单列表未分配
    return request({
      url: '/mtscitech/back/activityList/findResultsByRuleApplyUUID',
      method: 'get',
      params: query
    })
  }
  export function dealerstocklist(data) { // 经销商库存
    return request({
      url: '/mms/api/background/dealerstock/list',
      method: 'post',
      data
    })
  }
  export function dealerstockdetaillist(data) { // 经销商库存明细
    return request({
      url: '/mms/api/background/dealerstockdetail/list',
      method: 'post',
      data
    })
  }